import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const ButtonStyles = {
  "rounded-corners": "4px",
  "circular-corners": "50px",
  "default": 0
};

export const TemplateButton = ({
  type = 'primary', // 'primary', 'secondary', etc.
  variant = 'contained', // 'contained', 'outlined', 'text'
  textColor,
  backgroundColor,
  borderColor,
  fill,
  constrastText,
  fontFamily,
  ...rest
}) => {
  const theme = useTheme();

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  };

  // Determine the text color based on the props or mapped values
  let buttonTextColor = textColor
    ? paletteMapping[textColor] // textColor mapped from props
    : (type === 'primary' ? paletteMapping.textSecondary : paletteMapping.textPrimary);

  // Determine the background color based on the props or mapped values
  let buttonBackgroundColor = backgroundColor
    ? paletteMapping[backgroundColor] // backgroundColor mapped from props
    : (type === 'primary' ? paletteMapping.primary : paletteMapping.secondary);

  // Determine the border color for outlined variant or custom styling
  let buttonBorderColor = borderColor
    ? paletteMapping[borderColor] // borderColor mapped from props
    : (variant === 'outlined' ? buttonTextColor : 'transparent');

  let buttonIconFill = paletteMapping[fill] ?? 'inherit'

  return (
    <Button
      disableElevation
      variant={variant}
      sx={{
        textTransform: 'none',
        color: constrastText ? constrastText : buttonTextColor,
        backgroundColor: variant === 'contained' ? buttonBackgroundColor : 'transparent',
        borderColor: buttonBorderColor,
        borderWidth: variant === 'outlined' ? '1px' : 0,
        fill: buttonIconFill, // For icons
        '&:hover': {
          backgroundColor: variant === 'contained' ? buttonBackgroundColor : 'transparent',
        },
        borderRadius: ButtonStyles[theme.buttonStyle] ?? 0,
        fontFamily: fontFamily
      }}
      {...rest}
    />
  );
};

TemplateButton.propTypes = {
  type: PropTypes.string, // e.g., 'primary', 'secondary'
  variant: PropTypes.string, // 'contained', 'outlined', 'text'
  fill: PropTypes.bool,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  constrastText: PropTypes.string,
};

export default TemplateButton;
